import { Box, Button, Dialog } from '@mui/material';
import React, { useState } from 'react';
import useFetch from '../../../api/useFetch';
import LabeledBox from '../../special/LabeledBox';
import {
  Category,
  ExoLeadCategory,
} from '../../../scenes/leads/category/ExoLeadCategory';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useTranslation } from 'react-i18next';

export const TypeLeadCategory = ({
  updateValidationOnChange,
  dataCollection,
  errors,
  field,
  size,
  allowSelection,
}) => {
  const { apiData, setApiData } = useFetch(`lead-categories`);
  const { t } = useTranslation();
  const [openCategories, setOpenCategories] = useState(false);

  const selectedCategories = dataCollection && dataCollection[field.key];

  const handleRemove = (catId) => {
    const updated = selectedCategories?.filter((c) => c.id !== catId);
    updateValidationOnChange(field.key, updated);
  };

  return (
    <>
      <LabeledBox label={field.label} size={size}>
        <Box className="flex flex-col">
          {selectedCategories?.map((cat) => (
            <Category
              key={cat.id}
              category={cat}
              disableSettings
              onSelect={() => handleRemove(cat.id)}
            />
          ))}

          <Button
            className="flex items-center gap-4"
            color="secondary"
            onClick={() => setOpenCategories(true)}
            sx={{ mt: 1, alignSelf: 'flex-start' }}
          >
            <AddCircleIcon color="success" />
            {field.addLabel || t('Add')}
          </Button>
        </Box>
      </LabeledBox>

      <Dialog
        open={openCategories}
        onClose={() => setOpenCategories(false)}
        sx={{
          '.MuiPaper-root': {
            backgroundImage: 'unset!important',
          },
          '.MuiBackdrop-root': {
            backdropFilter: 'blur(1px)',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
          },
        }}
      >
        <ExoLeadCategory
          allowSelection={true}
          onSelect={(selected) => {
            updateValidationOnChange(field.key, selected);
          }}
          preSelected={selectedCategories}
          onClose={() => setOpenCategories(false)}
          categories={apiData}
          setCategories={setApiData}
        />
      </Dialog>
    </>
  );
};
